export default __webpack_public_path__ + "static/media/warning-color-icon.83ad34b1.svg";